import React from 'react'
import PresentationService from '../../Components/Service/PresentationService'
import { motion } from "framer-motion";
function Services() {
  return (
    <motion.div
      className="main"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0, transition: { duration: 0.5 } }}
    >
      <PresentationService />
    </motion.div>
  );
}

export default Services